import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'notification-template',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'notification-template',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'notification-template',
  action: ActionType.UPDATE,
};

export const NotificationTemplate = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
};
